import { useContext, useEffect, useRef } from 'react';
import { FiMail, FiMapPin, FiMessageCircle } from 'react-icons/fi';
import MarketingLayout from '../layouts/MarketingLayout';
import { ThemeContext } from '../context/ThemeContext';
import { SUPPORT_EMAIL } from '../config/emailjs';

function openContactForm() {
  window.dispatchEvent(new CustomEvent('openContactModal'));
}

/** Ruta /contacto: contenido visible + formulario en modal (navbar). */
export default function Contacto() {
  const { modoOscuro } = useContext(ThemeContext);
  const autoOpenedRef = useRef(false);

  useEffect(() => {
    if (autoOpenedRef.current) return;
    autoOpenedRef.current = true;
    const t = window.setTimeout(() => openContactForm(), 200);
    return () => window.clearTimeout(t);
  }, []);

  const bg = modoOscuro ? 'bg-black' : 'bg-white';
  const textPri = modoOscuro ? 'text-white' : 'text-gray-900';
  const textSec = modoOscuro ? 'text-gray-300' : 'text-gray-600';
  const box = modoOscuro ? 'bg-gray-900 border-gray-700' : 'bg-white border-gray-200';

  return (
    <MarketingLayout>
      <section className={`min-h-[calc(100dvh-8rem)] flex flex-col justify-center py-24 px-4 sm:px-6 ${bg}`}>
        <div className="max-w-xl mx-auto w-full text-center">
          <p className={`text-[11px] font-semibold tracking-[0.18em] uppercase mb-3 ${modoOscuro ? 'text-[#5CA3FF]' : 'text-[#004AAD]'}`}>
            Contacto
          </p>
          <h1 className={`text-3xl sm:text-4xl font-extrabold leading-tight mb-4 ${textPri}`}>
            Hablemos en simple
          </h1>
          <p className={`text-sm sm:text-base leading-relaxed mb-8 ${textSec}`}>
            Contanos tu caso: monotributo, cuántos clientes tenés, si trabajás con contador. Te respondemos en lenguaje claro.
          </p>

          <div className={`rounded-2xl border p-6 text-left space-y-4 shadow-sm mb-8 ${box}`}>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className={`flex items-start gap-3 text-sm ${textSec} hover:opacity-90`}
            >
              <FiMail className={`w-5 h-5 shrink-0 mt-0.5 ${modoOscuro ? 'text-[#5CA3FF]' : 'text-[#004AAD]'}`} />
              <span>
                <span className={`block font-semibold ${textPri}`}>Email</span>
                {SUPPORT_EMAIL}
              </span>
            </a>
            <p className={`flex items-start gap-3 text-sm ${textSec}`}>
              <FiMapPin className={`w-5 h-5 shrink-0 mt-0.5 ${modoOscuro ? 'text-[#5CA3FF]' : 'text-[#004AAD]'}`} />
              <span>
                <span className={`block font-semibold ${textPri}`}>Ubicación</span>
                CABA, Argentina · atención remota
              </span>
            </p>
            <p className={`text-xs ${modoOscuro ? 'text-gray-500' : 'text-gray-500'}`}>
              Horario habitual: lun–vie, respondemos en 24–48 h hábiles.
            </p>
          </div>

          <button
            type="button"
            onClick={openContactForm}
            className={`inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-semibold text-sm transition-colors ${
              modoOscuro ? 'bg-white text-black hover:bg-gray-200' : 'bg-gray-900 text-white hover:bg-black'
            }`}
          >
            <FiMessageCircle className="w-4 h-4" />
            Abrir formulario
          </button>
        </div>
      </section>
    </MarketingLayout>
  );
}
